function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#102E8E",
  fillRule: "evenodd",
  d: "M17.6 5.6V8H16a.8.8 0 00-.8.8v1.6h2.4v2.4h-2.4v5.6h-2.4v-5.6h-1.6v-2.4h1.6v-2c0-1.552 1.256-2.8 2.8-2.8h2zm.8-1.6H5.6A1.6 1.6 0 004 5.6v12.8A1.6 1.6 0 005.6 20h12.8a1.6 1.6 0 001.6-1.6V5.6A1.6 1.6 0 0018.4 4z"
});

var SvgIcFacebook = function SvgIcFacebook(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMxMDJFOEUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjYgNS42VjhIMTZhLjguOCAwIDAgMC0uOC44djEuNmgyLjR2Mi40aC0yLjR2NS42aC0yLjR2LTUuNmgtMS42di0yLjRoMS42di0yYzAtMS41NTIgMS4yNTYtMi44IDIuOC0yLjhoMnptLjgtMS42SDUuNkExLjYgMS42IDAgMCAwIDQgNS42djEyLjhBMS42IDEuNiAwIDAgMCA1LjYgMjBoMTIuOGExLjYgMS42IDAgMCAwIDEuNi0xLjZWNS42QTEuNiAxLjYgMCAwIDAgMTguNCA0eiIvPgo8L3N2Zz4K";
export { SvgIcFacebook as ReactComponent };